import React, { Component } from 'react';
import UserName from './UserName';
import UserPicture from './UserPicture';
import UserInfo from './UserInfo';
import UserPortalSelection from './UserPortalSelection';
import Divider from '@mui/material/Divider';
import AppContext from 'components/appContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons/faTimes';
import config from 'root/../config'

class UserDetails extends Component {
    static contextType = AppContext;

    constructor(props) {
        super(props);
    }

    toggleDrawer(open) {
        this.context.set('drawerOpen',open);
    }

    render() {
        return (
            <React.Fragment>
                {Object.keys(this.context.userDetails).length ?
                    <React.Fragment>
                        <div className="user-details-container">
                            <FontAwesomeIcon
                                icon={faTimes}
                                size={"1x"}
                                onClick={() => this.context.set('drawerOpen',false)} 
                                className="close-drawer-btn"
                            />
                            <div className="user-details__bg"></div>
                            <UserName />
                            <div className="user-details__wrapper">
                                <UserPicture />
                                <div className="user-details__info-wrapper">
                                    <UserInfo />
                                    <UserPortalSelection 
                                        userDetails={this.context.userDetails} 
                                        setUserDetails={this.context.setUserDetails} 
                                        drawer={this.props.drawer}
                                        toggleDrawer={this.toggleDrawer.bind(this)}
                                    />
                                </div>
                            </div>
                        </div>
                        <Divider />
                    </React.Fragment>
                    :
                    null
                }
            </React.Fragment>
        )
    }
}

export default UserDetails;